var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCastanha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4161 7.37592C15.7608 7.60568 15.8539 8.07134 15.6241 8.41598L13.6241 11.416C13.3944 11.7606 12.9287 11.8538 12.5841 11.624C12.2394 11.3942 12.1463 10.9286 12.376 10.5839L14.376 7.58393C14.6058 7.23929 15.0715 7.14616 15.4161 7.37592Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45459 4.22216L11.1261 2.17926C12.0026 1.10796 13.2838 0.44774 14.6649 0.355665C17.5522 0.163181 20 2.45325 20 5.34693V5.73368C20 6.56644 19.8061 7.38777 19.4337 8.13261L17 13L15.2472 15.6292C15.0699 15.8952 14.8785 16.1491 14.6744 16.3903C13.2455 18.0783 11.1918 19.1391 8.96077 19.3107L6.34131 19.5122C6.12752 19.5286 5.91568 19.5335 5.70639 19.5273C2.76866 19.4404 0.332167 17.1773 0.031251 14.2514C0.0105935 14.0506 2.60623e-07 13.8466 0 13.64C0 13.64 0 13.64 0 13.64C0 13.0823 0.0787741 12.5365 0.228112 12.016C0.675831 10.4556 1.75779 9.12214 3.25274 8.37362C3.25372 8.37313 3.2547 8.37264 3.25568 8.37215L5.94322 7.02838C7.29833 6.35083 8.49493 5.39452 9.45459 4.22216ZM15.1972 13H12.2315C11.419 13 10.6149 13.165 9.86803 13.4851L8.18176 14.2078C6.20215 15.0562 4 13.6041 4 11.4504V9.67704L6.61404 8.37002C7.64804 7.85302 8.60105 7.1936 9.44624 6.4132L10.5647 6.73277C11.1727 6.90647 11.8199 6.88365 12.4141 6.66758L14.3165 5.97581C15.6209 5.50149 17 6.46746 17 7.85539V9.64589L15.7001 12.2456L15.1972 13Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastanha);
export default __webpack_public_path__ + "static/media/castanha.271d44d36e4ea31d7f791e1bf7d1d3b7.svg";
export { ForwardRef as ReactComponent };